import {AppBar, Box, Button, IconButton, Toolbar} from "@mui/material";
import {LanguageSwitcher, VCLogoBlueOrange} from "@variocube/app-ui";
import React, {useCallback} from "react";
import {Link as RouterLink} from "react-router-dom";
import {useTenant} from "../context/tenant";
import {SUPPORTED_LANGUAGES, useLocalization} from "../i18n";
import {notBlank} from "../utils";

import CityLockerStoreLogo from "../assets/city-locker-store-logo.png";
import CityLockerLogo from "../assets/city-locker_logo_rgb_main.svg";
import CityLockersLtd from "../assets/citylokcers-al.png";
import HoldMyBagLogo from "../assets/HOLDMYBAG-LOGO-2025-10.svg";
import IntechLogo from "../assets/intech-ics-logo.jpg";
import MaagLogo from "../assets/maag.png";
import SchluessfachLogo from "../assets/schluessfach-weiss.svg";
import {LogoDisplay} from "./logo-display";

export function BrandingBar() {
	const {tenant} = useTenant();
	const {t, ...rest} = useLocalization();

	const renderTenantLogo = useCallback(() => {
		const tenantId = tenant?.id ?? "variocube";

		if (location.hostname.includes("holdmybag")) {
			return <HoldMyBagLogo width="auto" height="48px" />;
		}
		switch (tenantId) {
			case "citylocker":
				return <CityLockerLogo width="auto" height="48px" />;
			case "schluessfach":
			case "the-lobby-6":
				return <SchluessfachLogo width="auto" height="48px" />;
			case "maag-music-arts-ag":
				return <img style={{height: "70px", width: "auto"}} alt={tenant?.name} src={MaagLogo} />;
			case "citylocker-store":
				return (
					<img
						style={{height: "70px", width: "auto", padding: "8px"}}
						alt="citylocker-store"
						src={CityLockerStoreLogo}
					/>
				);
			case "intech-schweiz":
				return <img style={{height: "48px", width: "auto", padding: "8px"}} alt="intech" src={IntechLogo} />;
			case "in-stuttgart":
			case "d-live-duesseldorf":
			case "acama-kreuzberg":
			case "elenas-apartments":
			case "podersdorf":
			case "balmers-hostel":
			case "three-friends":
			case "gateway-gardens-ocean-club":
			case "waltherpark-spa":
			case "str-kultur-und-betriebs-gmbH":
			case "wyndham-salzburg":
				return <HoldMyBagLogo width="auto" height="48px" />;
			case "city-lockers-ltd":
				return (
					<img
						style={{height: "48px", width: "auto", padding: "8px"}}
						alt="Logo City Lockers Ltd"
						src={CityLockersLtd}
					/>
				);
			default:
				const logoUrl = tenant?.branding?.logoLightUrl
					? tenant?.branding?.logoLightUrl
					: tenant?.branding?.logoDarkUrl;
				if (logoUrl) {
					return <LogoDisplay url={logoUrl} tenantId={tenantId} />;
				}
				return <VCLogoBlueOrange width="auto" height="32px" />;
		}
	}, [tenant]);

	return (
		<AppBar
			position="static"
			color="transparent"
			elevation={0}
		>
			<Toolbar>
				<IconButton
					disableRipple
					component={RouterLink}
					to={`/${tenant?.id}`}
				>
					{renderTenantLogo()}
				</IconButton>
				<Box flexGrow={1} />
				{notBlank(tenant?.imprintUrl) && (
					<Button
						component={RouterLink}
						to={tenant?.imprintUrl as string}
						target="_blank"
					>
						{t("imprint")}
					</Button>
				)}
				{tenant?.id && (
					<LanguageSwitcher
						languages={SUPPORTED_LANGUAGES}
						color="inherit"
						{...rest}
					/>
				)}
			</Toolbar>
		</AppBar>
	);
}
